import apiConfig from '../config/api.config';

const config = {
  url: apiConfig.apiUrl,
  baseUrl: apiConfig.baseUrl,
  endpoint: apiConfig.endpoint,
  environment: apiConfig.environment,
};

export default config;
